import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {
  Box,
  Button,
  Checkbox,
  Text,
  Heading,
  Alert,
  Divider,
  IconButton,
  CloseIcon,
} from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { BulkUploadTypes } from 'constants/bulkUpload';
import { dateFormats, getFormattedDateValue } from 'utils/Dates';

interface LocationState {
  payrollMonth?: string;
}

const ConfirmationStep = () => {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const [isConfirmed, setIsConfirmed] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const payrollMonth = searchParams.get('payrollMonth') || location.state?.payrollMonth || '';

  const payrollMonthFormatted = getFormattedDateValue({
    date: payrollMonth,
    formatString: dateFormats.monthYear,
    filler: '',
  });

  const handleGoBackAndClose = () => {
    window.location.href = routePaths.phpRoutes.salaryRegister;
  };

  const handleProceed = () => {
    if (isConfirmed) {
      history.push({
        pathname: routePaths.bulkUploads.initiate,
        search: `type=${BulkUploadTypes.TYPE_BULK_SALARY_REGISTER_UPDATE}&payrollMonth=${payrollMonth}`,
      });
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      backgroundColor="surface.background.gray.subtle"
      padding="spacing.5">
      <Box
        backgroundColor="surface.background.gray.intense"
        borderRadius="large"
        width="500px"
        elevation="highRaised"
        display="flex"
        flexDirection="column"
        gap="spacing.7">
        <Box
          paddingX="spacing.7"
          paddingTop="spacing.7"
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between">
          <Box>
            <Heading size="medium" weight="medium">
              Update Salary Register
            </Heading>
            <Text size="medium" color="surface.text.gray.muted" marginTop="spacing.2">
              for {payrollMonthFormatted} Payroll
            </Text>
          </Box>
          <Box>
            <IconButton
              icon={CloseIcon}
              accessibilityLabel="Close"
              emphasis="intense"
              size="large"
              onClick={handleGoBackAndClose}
            />
          </Box>
        </Box>

        <Divider orientation="horizontal" />

        <Box paddingX="spacing.7" display="flex" flexDirection="column" gap="spacing.7">
          <Alert
            color="information"
            emphasis="subtle"
            isDismissible={false}
            description={
              <Box>
                <Text size="medium" color="surface.text.gray.subtle">
                  Please ensure that you upload past executed salary register. Do not upload any
                  pending payroll month's salary register through this flow
                </Text>
              </Box>
            }
          />
          <Box width="90%">
            <Checkbox
              isChecked={isConfirmed}
              onChange={({ isChecked }) => setIsConfirmed(isChecked)}>
              {` I am uploading already executed salary register of ${payrollMonthFormatted}`}
            </Checkbox>
          </Box>
        </Box>

        <Divider orientation="horizontal" />

        <Box
          paddingX="spacing.7"
          paddingBottom="spacing.7"
          display="flex"
          gap="spacing.4"
          justifyContent="flex-end">
          <Button variant="secondary" onClick={handleGoBackAndClose}>
            Go Back
          </Button>
          <Button variant="primary" onClick={handleProceed} isDisabled={!isConfirmed}>
            Proceed
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ConfirmationStep;
